import {motion} from "framer-motion";
import {Link, useLocation} from "react-router-dom";
import {HashLink} from 'react-router-hash-link';
import {AriaRole, ReactNode} from "react";

interface AnimatedLinkProps {
    children: ReactNode;
    to: string;
    className?: string;
    onClick?: (e: any) => void;
    role?: AriaRole
    bounceEffect?: boolean;
    customScale?: number;
    initial?: {};
    delay?: number;
    hashLink?: boolean
    state?: any
    replaceLinkWithAHref?: boolean
    openLinkInNewTab?: boolean
    style?: any
    preserveSearchParams?: boolean
}

export default function AnimatedLink(props: AnimatedLinkProps) {
    const {
        children, to, className, onClick, role,
        bounceEffect, customScale, initial, delay, hashLink, state,
        replaceLinkWithAHref, openLinkInNewTab, style,
        preserveSearchParams = true
    } = props
    const MotionLink = motion(hashLink ? HashLink : Link);
    const location = useLocation();

    let processedTo = to;
    if (hashLink && preserveSearchParams && to.startsWith('#') && location.search) {
        processedTo = `${location.pathname}${location.search}${to}`;
    }

    return <>
        {
            replaceLinkWithAHref ? <motion.a
                    className={className}
                    href={processedTo}
                    whileHover={{scale: customScale ? customScale : 1.1}}
                    transition={bounceEffect ? {type: 'spring', stiffness: 400, delay: delay} : {delay: delay}}
                    role={role}
                    onClick={onClick}
                    initial={initial}
                    animate={{opacity: 1, x: 0}}
                    style={style}
                >
                    {children}
                </motion.a> :
                <MotionLink
                    target={openLinkInNewTab ? "_blank" : undefined}
                    className={className}
                    to={processedTo}
                    whileHover={{scale: customScale ? customScale : 1.1}}
                    transition={bounceEffect ? {type: 'spring', stiffness: 400, delay: delay} : {delay: delay}}
                    role={role}
                    onClick={onClick}
                    initial={initial}
                    animate={{opacity: 1, x: 0}}
                    state={state ?? {}}
                    style={style}
                >
                    {children}
                </MotionLink>
        }

    </>
}